<template>
<body>
  <cursor-fx ref="cursor" color="#6B4000" color-hover="#FA9732" inside-size="15px" outside-size="90px"></cursor-fx>
  <div class="all_box">

    <div class="member_head_5">
      <div class="apply_btn_box">
        <router-link to="ApplicationForm">
          <btn class="apply_btn" data-cursor-hover>
            応募する
          </btn>
        </router-link>
      </div>
      <div class="cb" />
      <div class="title_box_member">
        <div>
          <div class="title_h1_member en_font">Tomohiro.M</div>
          <div class="title_h2_member en_font">engineer</div>
        </div>
      </div>
    </div>
    <div class="Portal_box">
      <div class="Portal_contents">

        <div class="profile_title en_font">PROFILE</div>
        <div class="profile_box">
          <div class="profile_contents jp_font">
            2022年1月に中途入社。
            前職では、SES営業とスマートフォン販売業を兼業。<br />
            営業活動の際にHESと出会い、入社。<br />
            「現場を知り、近い目線でエンジニアをケアできるSES営業」を目指し、エンジニアとしての知識や経験、スキルを身につけるために日々勉強中。<br />
            【趣味】キャンプ・音楽・漫画・アニメ
          </div>
        </div>

        <div class="interview_q q_chance jp_font">転職のきっかけは何ですか？</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            前職でIT業界に関わり、SESという業態を知りました。<br />
            営業として顧客先や担当エンジニアなど多くの人と関わる中で、派遣される人材を「商品」としてしか見ることのできない人がいることに違和感を感じました。<br /><br />
            そんななかで、HESの営業と会話する機会があり「人」として接している姿勢に感銘をうけました。<br />
            「人」として見ているからこそ、スキルだけではなく現場に本当の意味でマッチングするかを大事にされており、自分もこんな営業になりたいと強く思ったことがきっかけです。<br />
            転職前に面談を繰り返し、一人一人の個性や生き方を活かそうとする社風に惹かれ、転職を決意しました。
          </div>
        </div>

        <div class="interview_q q_charm jp_font">職場環境の魅力（社風、人間関係、勤務地）をお教えください。</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            社風は、一人一人の個性を重視し、仕事だけではなくプライベートも大切にしてくれる会社だと思います。<br /><br />
            人間関係は、同僚と一緒にランチに行ったり、共通の趣味で繋がっていたり、一人で好きなことをやったりと適度な距離感が保たれていると感じています。<br />
            業務面では、部署の垣根をこえて協力できるメンバが多く、困難にぶつかった際でもすぐに相談できることが魅力です。<br /><br />
            勤務地は原則テレワークか大森駅至近のオフィスでの勤務となります。<br />
            駅から近く、通勤は比較的楽に感じています。駅周辺にはコンビニや飲食店が多く、ちょっとした買い物やアフターワークを楽しむこともできます。<br />
          </div>
        </div>

        <div class="member_photo5" />
        <div class="member_photo_space1" />

        <div class="interview_q q_goal jp_font">今後の目標をお教えください。</div>
        <div class="interview_box">
          <div class="interview_a jp_font">
            「現場やエンジニアに寄り添える営業」として活躍することです。<br />
            「寄り添う」上で相手のことを理解することが大切であると考えています。<br />
            そのためにまずは現場でエンジニアとして働き、エンジニアの「立場」を実体験してみようと思い現在はエンジニア業務に従事しています。<br />
            将来はこの経験を生かし、現場とエンジニアの両方に寄り添った営業になることを目標としています。
          </div>
        </div>
          
      </div>
    </div>
    
    <div class="other_member">
      <div class="other_member_title">
        <div class="other_member_chara en_font">OTHER MEMBER</div>
      </div>

      <div class="other_member_contents">

        <!-- <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/takahashi_test.jpg" alt="">
          <p class="other_member_name">Takahashi<br />Yuta</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/otsuka_test.jpg" alt="">
          <p class="other_member_name">Otsuka<br />Chiaki</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="cb" />

        <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/yamada_test.jpg" alt="">
          <p class="other_member_name">Yamada<br />Mina</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item">
          <img class="other_member_img" src="../../assets/member/miyama_test.jpg" alt="">
          <p class="other_member_name">Miyama<br />Tomohiro</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="cb" /> -->



        <!-- <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/takahashi_test.jpg" alt="">
          <p class="other_member_name">Takahashi<br />Yuta</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/otsuka_test.jpg" alt="">
          <p class="other_member_name">Otsuka<br />Chiaki</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/yamada_test.jpg" alt="">
          <p class="other_member_name">Yamada<br />Mina</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div>
        <div class="other_member_item2">
          <img class="other_member_img" src="../../assets/member/miyama_test.jpg" alt="">
          <p class="other_member_name">Miyama<br />Tomohiro</p>
          <div class="other_member_box jp_font">
            中途シニアエンジニア1
            <div class="other_member_box2">
              <div class="other_member_box3 jp_font">
                自分の「やりたい」を<br />
                1ミリも曲げなくていい場所。
              </div>
            </div>
          </div>
        </div> -->





        <div class="Member_Member_wrap">
          <div class="Member_Member_item Member_Member_img_Animation1" data-cursor-hover><router-link to="MemberInterview1">
            <img src="../../assets/member/icon_422A8495_2048px.jpg">
            <p class="Member_Member_item_role en_font">senior engineer</p>
            <p class="Member_Member_item_text en_font">Takahiro.O</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <div class="Member_Member_item Member_Member_img_Animation1" data-cursor-hover><router-link to="MemberInterview2">
            <img v-lazy="require('@/assets/member/icon_422A8652_2048px.jpg')">
            <p class="Member_Member_item_role en_font">leader engineer</p>
            <p class="Member_Member_item_text en_font">Yuta.T</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <div class="Member_Member_item Member_Member_img_Animation2" data-cursor-hover><router-link to="MemberInterview3">
            <img v-lazy="require('@/assets/member/icon_422A8581_2048px.jpg')">
            <p class="Member_Member_item_role en_font">general affairs</p>
            <p class="Member_Member_item_text en_font">Chiaki.O</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <div class="Member_Member_item Member_Member_img_Animation3" data-cursor-hover><router-link to="MemberInterview4">
            <img v-lazy="require('@/assets/member/icon_422A8539_2048px.jpg')">
            <p class="Member_Member_item_role en_font">engineer</p>
            <p class="Member_Member_item_text en_font">Mina.Y</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div>

          <!-- <div class="Member_Member_item Member_Member_img_Animation4" data-cursor-hover><router-link to="MemberInterview5">
            <img v-lazy="require('@/assets/member/icon_422A8423_2048px.jpg')">
            <p class="Member_Member_item_role en_font">engineer</p>
            <p class="Member_Member_item_text en_font">Tomohiro.M</p>
            <div class="Member_Member_item_text2 en_font"><p class="view_more">View More</p></div></router-link>
          </div> -->

        </div>
        <div class="cb" />


      </div>

    </div>
  
  
  </div>
</body>
</template>


<style>
@import "../../css/Portal_base.css";
@import "../../css/Portal_base_memberinterview.css";

</style>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export default {
  data () {
    return {

    }
  },
  methods: {
    startMaintitle() {
      gsap.fromTo('.Member_Member_img_Animation1', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation2', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.3,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation3', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.6,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation4', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.9,
          opacity: 1,
        }
      ),
      gsap.fromTo('.Member_Member_img_Animation5', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".Member_Member_item",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 2.1,
          opacity: 1,
        }
      )
    }
      
  },
  mounted() {
    this.startMaintitle()
  }
}

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

</script>
